// projectDetials.js

import { PROJECT_DETAILS_FAILURE, PROJECT_DETAILS_REQUEST, PROJECT_DETAILS_SUCCESS } from "../Actions/Actions";


const initialState = {
  isLoading: false,
  project: [],
  error: null,
};

const projectDetailsReducer = (state = initialState,{type,payload}) => {
  switch (type) {
    case PROJECT_DETAILS_REQUEST:
      return { ...state, isLoading: true, error: null };
    case PROJECT_DETAILS_SUCCESS:
      return { ...state, isLoading: false, project: payload };
    case PROJECT_DETAILS_FAILURE:
      return { ...state, isLoading: false, error: payload };
    default:
      return state;
  }
};

export default projectDetailsReducer;
